import { createAction, props } from '@ngrx/store';
import { AdminCustomerDPApiError } from './admin-customer-dp.errors';
import { CustomerDP } from '../../admin/models/customer-dp.model';

export enum AdminCustomerDPActionTypes {
  LoadCustomerDPsAction = '[Admin Customer DP] Load Customer DPs',
  LoadCustomerDPsCsvAction = '[Admin Customer DP] Load Customer DPs Csv',
  CustomerDPsLoadedAction = '[Admin Customer DP] Customer DPs Loaded',
  CustomerDPsCsvLoadedAction = '[Admin Customer DP] Customer DPs Csv Loaded',
  CustomerDPErroredAction = '[Admin Customer DP] Customer DPs Errored',
  CustomerDPCsvErroredAction = '[Admin Customer DP] Customer DPs Csv Errored',
  DeleteCustomerDPClickedAction = '[Admin Customer DP] Delete Customer DP Clicked',
  CustomerDPDeletedAction = '[Admin Customer DP] Customer DP Deleted',
  CustomerDPDeleteErroredAction = '[Admin Customer DP] Customer DP Delete Errored',
}

export const LoadCustomerDPsAction = createAction(AdminCustomerDPActionTypes.LoadCustomerDPsAction);

export const LoadCustomerDPsCsvAction = createAction(
  AdminCustomerDPActionTypes.LoadCustomerDPsCsvAction,
);

export const CustomerDPsLoadedAction = createAction(
  AdminCustomerDPActionTypes.CustomerDPsLoadedAction,
  props<{ customerDPs: CustomerDP[] }>(),
);

export const CustomerDPsCsvLoadedAction = createAction(
  AdminCustomerDPActionTypes.CustomerDPsCsvLoadedAction,
);

export const CustomerDPErroredAction = createAction(
  AdminCustomerDPActionTypes.CustomerDPErroredAction,
  props<{ error: AdminCustomerDPApiError }>(),
);

export const CustomerDPCsvErroredAction = createAction(
  AdminCustomerDPActionTypes.CustomerDPCsvErroredAction,
  props<{ error: AdminCustomerDPApiError }>(),
);

export const DeleteCustomerDPClickedAction = createAction(
  AdminCustomerDPActionTypes.DeleteCustomerDPClickedAction,
  props<{ customerDPId: string }>(),
);

export const CustomerDPDeletedAction = createAction(
  AdminCustomerDPActionTypes.CustomerDPDeletedAction,
);

export const CustomerDPDeleteErroredAction = createAction(
  AdminCustomerDPActionTypes.CustomerDPDeleteErroredAction,
  props<{ error: AdminCustomerDPApiError }>(),
);
